import React from "react";
// node.js library that concatenates classes (strings)
import classnames from "classnames";

import axios from 'axios';

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col
} from "reactstrap";

import GenericHeader from "components/Headers/GenericHeader.js";
// import Spinner from "views/examples/Spinner.js";
import Moment from "moment";
import 'moment/locale/el';

import { MDBDataTable } from 'mdbreact';

import '../../../assets/css/datatable.css';

class OldInstances extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      userDetails: [],
      instances: [],
    };
  }

  componentDidMount() {
    if (localStorage.getItem('token')) {
      fetch(process.env.REACT_APP_API_LINK + "/api/auth/user/", {
        method: 'get',
        headers: new Headers({
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'Content-Type': 'application/x-www-form-urlencoded'
        })
      })
        .then(res => res.json())
        .then((result) => {
          // console.log(result);
          this.setState({
            userDetails: result
          });
        })

      axios.get(process.env.REACT_APP_API_LINK + "/api/consumer/oldinstances/current/", {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      })
        .then(res => {
          // console.log(res.data);

          var WorkflowInstance_Table = [];

          res.data.forEach((item) => {
            item[0].user = item[1].Receiver[0];
            WorkflowInstance_Table.push(item[0]);
          });

          // var myuser = this.state.user.PersonRole;
          const instances2 = WorkflowInstance_Table;
          instances2.forEach(function (part, index) {
            this[index].NewStatus = this[index].Status == 1 ? "1. Υποβολή Αιτήματος" : this[index].Status == 2 ? "2. Επεξεργασία Αιτήματος" : this[index].Status == 3 ? "3. Αίτημα προς Ολοκλήρωση" : this[index].Status == 4 ? "4. Απευθείας Απόρριψη" : this[index].Status == 5 ? "5. Ολοκλήρωση Αιτήματος" : "";
            // this[index].NewSerialNumber = parseInt(this[index].SerialNumber + '00' + (this[index].SubmittedAt.toString()).substring(0, 4));
            // var dateArray = ((this[index].SubmittedAt).toString()).split('T');
            // var timeArray = dateArray[1].split(':');
            // this[index].NewSubmittedAt = dateArray[0] + ' - ' + timeArray[0] + ':' + timeArray[1];
            // this[index].Data = res[1].Data[index];
            this[index].Buttons =
              <React.Fragment>
                <Button
                  color="primary"
                  href={"/consumer/instance/" + this[index].Id}
                  size="sm"
                  title="Στοιχεία"
                >
                  <i className="fas fa-eye" />
                </Button>
              </React.Fragment>

          }, instances2);
          this.state.datas = {
            columns: [
              {
                label: 'Αριθμος Αιτησης ▼',
                field: 'SerialNumber',
                sort: 'desc',
                width: 100,
                viewColumns: false
              },
              {
                label: 'Κατάσταση ▼',
                field: 'NewStatus',
                sort: 'asc',
                width: 100
              },
              {
                label: 'Παραλήπτης ▼',
                field: 'user',
                sort: 'asc',
                width: 100
              },
              {
                label: 'Ενέργειες ▼',
                field: 'Buttons',
                sort: 'asc',
                width: 100
              },
            ],
            rows: WorkflowInstance_Table,
          };

          this.setState({
            instances: WorkflowInstance_Table
          });
        })
    };
  }

  render() {
    return (
      <>
        <GenericHeader />
        {/* Page content */}
        <Container className="mt--8" fluid>
          <Row className="mt-5">
            <Col className="mb-5 mb-xl-0" xl="12">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">Ολοκληρωμένα Αιτήματα</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                      {this.state.userDetails.Email != "deletedusers@rae.gr" ?
                        <>
                          <Button
                            color="success"
                            href="/admin/newinstance"
                            size="sm"
                          >
                            Προσθήκη νέας αίτησης
                          </Button>
                        </> : <></>
                      }
                    </Col>
                  </Row>

                </CardHeader>
                {/* <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Α/Α</th>
                      <th scope="col">Κατασταση</th>
                      <th scope="col">Ενεργειες</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.instances.map((dynamicData) =>
                        <tr>
                          <th scope="row"> {dynamicData.SerialNumber}/{(dynamicData.SubmittedAt.toString()).substring(0, 4)}</th>
                          {dynamicData.Status == 1 ? <td>1. Υποβολή Αιτήματος</td> : <> </>}
                          {dynamicData.Status == 2 ? <td>2. Επεξεργασία Αιτήματος</td> : <> </>}
                          {dynamicData.Status == 3 ? <td>3. Ολοκληρωμένο Αίτημα</td> : <> </>}
                          {dynamicData.Status == 4 ? <td>4. Διευκρίνιση σε περίπτωση απόρριψης</td> : <> </>}
                          <td><Button
                            color="primary"
                            href={"/consumer/instance/" + dynamicData.Id}
                            size="sm"
                            title="Επεξεργασία"
                          >
                            <i className="fas fa-eye" /> */}
                {/* </Button> */}
                {/* <Button
                              color="danger"
                              onClick={() => { this.handleClick(dynamicData.Id) }}
                              size="sm"
                              title="Διαγραφή"
                            >
                              <i className="fas fa-trash" />
                            </Button> */}
                {/* </td>
                        </tr>
                      )
                    }
                  </tbody>
                </Table> */}

                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <MDBDataTable
                        bordered
                        exportToCSV
                        hover
                        responsive
                        strip
                        data={this.state.datas}
                        id="mdbdttable"
                        entriesOptions={[10, 25, 50, 100, 500, 1000]} entries={10}
                        noDataComponent="Δεν υπάρχουν δεδομένα"
                        searchLabel="Αναζήτηση"
                        paginationLabel={['Προηγούμενο', 'Επόμενο']}
                        infoLabel={['Εμφανίζονται', 'έως', 'από', 'καταχωρήσεις']}
                        entriesLabel={'Εμφάνιση Αιτημάτων ανά: '}
                      />
                    </div>

                  </Row>
                </CardHeader>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default OldInstances;
